<template>
    <Teleport to="body">
        <transition name="fade">
            <div
                v-if="isOpen"
                class="fixed inset-0 z-50"
                :aria-hidden="isOpen"
                aria-labelledby="modal-title"
                role="dialog"
            >
                <!-- Overlay -->
                <div
                    class="absolute inset-0 bg-black/50"
                    @click="$emit('close')"
                ></div>

                <!-- Modal panel -->
                <div
                    class="absolute bottom-0 left-0 w-full bg-white dark:bg-slate-800 rounded-t-2xl shadow-xl dark:shadow-slate-900/50 flex flex-col animate-slide-up max-h-[99vh]"
                >
                    <!-- Header - Fixed at top -->
                    <div
                        class="flex items-center justify-between px-6 pt-6 pb-4 bg-white dark:bg-slate-800 z-10 rounded-t-2xl"
                    >
                        <slot name="header">
                            <h2 class="text-xl font-medium text-slate-800 dark:text-slate-100">
                                {{ title }}
                            </h2>
                            <button
                                @click="$emit('close')"
                                class="btn-base btn-icon !m-0"
                            >
                                <Icon icon="x" class="text-slate-500 dark:text-slate-400" />
                            </button>
                        </slot>
                    </div>

                    <!-- Content - Scrollable -->
                    <div class="px-6 py-4 overflow-y-auto flex-1 transition-all duration-300 ease-in-out">
                        <slot name="content" />
                    </div>

                    <!-- Footer - Fixed at bottom -->
                    <div v-if="$slots.footer" class="px-4 py-3 bg-white dark:bg-slate-800 z-10">
                        <slot name="footer" />
                    </div>
                </div>
            </div>
        </transition>
    </Teleport>
</template>

<script setup>
import Icon from '@/components/ui/icon/icon.vue';

defineProps({
    isOpen: {
        type: Boolean,
        default: false,
    },
    title: {
        type: String,
        default: 'Sort by',
    },
    icon: {
        type: String,
        default: null,
    },
    iconColor: {
        type: String,
        default: 'slate',
    },
});

defineEmits(['close']);
</script>

<style scoped></style>
